import { render } from "./NoAccount.vue?vue&type=template&id=c1ab22f6"
const script = {}

import "./NoAccount.vue?vue&type=style&index=0&id=c1ab22f6&lang=css"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__